import { ReactNode, createContext } from 'react';
import { useProfile } from 'edrolo/domains/profile';
import { Profile } from '../types/Profile';

interface Props {
  children: ReactNode;
}

interface iUserContext {
  profile: Profile;
}

const UserContext = createContext({} as iUserContext);

const UserProvider = ({ children }: Props) => {
  const { profile } = useProfile();

  const userContext: iUserContext = {
    profile,
  };

  return (
    <UserContext.Provider value={userContext}>{children}</UserContext.Provider>
  );
};

export { UserProvider, UserContext };
